import { render } from "./SelectedRoomHeader.vue?vue&type=template&id=313f77d0"
import script from "./SelectedRoomHeader.vue?vue&type=script&lang=js"
export * from "./SelectedRoomHeader.vue?vue&type=script&lang=js"

import exportComponent from "D:\\server\\www\\greativ\\ui\\template\\superSkypark\\moduleTmpl\\roomRent\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__